const testimonials = [
  {
    name: "Robert K.",
    location: "Pompano Beach, FL",
    rating: 5,
    text: "I run a fishing charter out of Pompano Beach and got invited to a tournament in the Bahamas on 4 days notice. My passport had expired two months ago. Fast Passport Center got me sorted and I had my new passport in 3 days. Made the tournament with time to spare.",
    service: "Passport Renewal",
  },
  {
    name: "Linda M.",
    location: "Lighthouse Point, FL",
    rating: 5,
    text: "Our cruise from Port Everglades was leaving in 10 days and my husband's passport was nowhere to be found. FPC walked us through the replacement, told us exactly which post office clerk to visit in Lighthouse Point, and had his passport back in under a week. We would have missed the entire trip.",
    service: "Lost Passport Replacement",
  },
  {
    name: "James T.",
    location: "Deerfield Beach, FL",
    rating: 5,
    text: "Business conference in London got moved up by two weeks. I thought I was stuck. Called FPC, started the order same day, shipped from Deerfield overnight, and had my passport in 5 days. Their team kept me updated every step of the way.",
    service: "Expedited Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PompanoTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Broward County Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Pompano Beach, Lighthouse Point, and Deerfield Beach who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}